module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzbzhubo-wrapper"
  }, [(!_vm.isHostObsLive && _vm.userInfo.cameraStatus !== 0) ? _c('div', {
    staticClass: "xtzbzhubo-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.videoContainerId
    }
  }) : (_vm.isHostObsLive && _vm.hostPullUrl) ? _c('video', {
    staticClass: "xtzbzhubo-video obs-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.obsPlayerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }) : _c('div', {
    staticClass: "xtzbzhubo-bg"
  }, [_c('img', {
    staticClass: "xtzbzhubo-bg-img",
    attrs: {
      "src": _vm.userInfo.userInfo && _vm.userInfo.userInfo.headPortrait,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-item-user"
  }, [_c('span', {
    staticClass: "xtzb-item-user-sort"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-item-user-name"
  }, [_vm._v("主播")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe7aa81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xietongzhubo/xietongzhubo.vue
// module id = 1044
// module chunks = 1